/**
 * Telemetry Metric Types
 *
 * Defines the available telemetry metrics for analysis.
 * This is the core type used across all frontends.
 *
 * Note: Display configuration (labels, colors, formatting) is intentionally
 * NOT included here - that belongs in each frontend's presentation layer.
 */

/**
 * Available telemetry metrics for analysis and visualization
 */
export type TelemetryMetric =
  | 'speed'
  | 'timeDrift'
  | 'coasting'
  | 'lateralG'
  | 'leanAngle'
  | 'acceleration'
  | 'brake'
  | 'throttle'

/**
 * Array of all available metrics (for iteration)
 */
export const ALL_METRICS: TelemetryMetric[] = [
  'speed',
  'timeDrift',
  'coasting',
  'lateralG',
  'leanAngle',
  'acceleration',
  'brake',
  'throttle',
]

/**
 * Check if a string is a valid TelemetryMetric
 */
export function isValidMetric(value: string): value is TelemetryMetric {
  return ALL_METRICS.includes(value as TelemetryMetric)
}
